import * as React from 'react';
import { StatusBadge, type StatusTone } from '../../primitives/StatusBadge';

/**
 * StatusCell — wraps StatusBadge with auto-mapping from common service /
 * invoice / domain status enums. Pass a free `tone` if you've already
 * resolved it.
 */

const AUTO_MAP: Record<string, StatusTone> = {
  active: 'active',
  paid: 'paid',
  pending: 'pending',
  expiring: 'expiring',
  overdue: 'overdue',
  failed: 'failed',
  draft: 'draft',
  open: 'info',
  closed: 'draft',
  resolved: 'active',
  suspended: 'failed',
  cancelled: 'draft',
  canceled: 'draft',
  expired: 'overdue',
  trial: 'beta',
  beta: 'beta',
  featured: 'featured',
};

interface StatusCellProps {
  /** A status string we know how to map (status enum) … */
  status?: string;
  /** … or an explicit tone. */
  tone?: StatusTone;
  /** Display label. Defaults to `status` titlecased. */
  label?: React.ReactNode;
  dot?: boolean;
}

function titlecase(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

function StatusCell({ status, tone, label, dot }: StatusCellProps) {
  const resolvedTone: StatusTone =
    tone ?? (status ? AUTO_MAP[status.toLowerCase()] : undefined) ?? 'draft';
  const resolvedLabel = label ?? (status ? titlecase(status) : '—');
  return (
    <StatusBadge tone={resolvedTone} dot={dot}>
      {resolvedLabel}
    </StatusBadge>
  );
}

export { StatusCell };
export type { StatusCellProps };
